var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "radio button/element/checked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 37.1654C29.2049 37.1654 36.6668 29.7034 36.6668 20.4987C36.6668 11.294 29.2049 3.83203 20.0002 3.83203C10.7954 3.83203 3.3335 11.294 3.3335 20.4987C3.3335 29.7034 10.7954 37.1654 20.0002 37.1654ZM20.0002 12.1654C20.9206 12.1654 21.6668 12.9116 21.6668 13.832V18.832H26.6668C27.5873 18.832 28.3335 19.5782 28.3335 20.4987C28.3335 21.4192 27.5873 22.1654 26.6668 22.1654H21.6668V27.1654C21.6668 28.0858 20.9206 28.832 20.0002 28.832C19.0797 28.832 18.3335 28.0858 18.3335 27.1654V22.1654H13.3335C12.413 22.1654 11.6668 21.4192 11.6668 20.4987C11.6668 19.5782 12.413 18.832 13.3335 18.832H18.3335V13.832C18.3335 12.9116 19.0797 12.1654 20.0002 12.1654Z",
    fill: "#2A85FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.3da035c70c5a6aee1ca272b8d6b66d4b.svg";
export { ForwardRef as ReactComponent };